var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("date-and-location", {
        attrs: { "is-read-only": _vm.isReadOnly },
        model: {
          value: _vm.model.detail,
          callback: function($$v) {
            _vm.$set(_vm.model, "detail", $$v)
          },
          expression: "model.detail"
        }
      }),
      _c("skill", {
        attrs: { "is-read-only": _vm.isReadOnly },
        model: {
          value: _vm.model,
          callback: function($$v) {
            _vm.model = $$v
          },
          expression: "model"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }